export const saveErrorText = (data, fallback) => {
  if (Object.keys(data?.validationErrors || {}).length > 0) return 'Проверьте отмеченные поля'

  return data?.message || fallback
}

export const notificationLanguages = [
  { code: 'ru', name: 'Русский' },
  { code: 'ky', name: 'Кыргызча' },
  { code: 'en', name: 'English' },
]

export const languageName = code => (notificationLanguages.find(x => x.code === code) || { name: code }).name

const channels = {
  MobilePush: 'Приложение',
  WebPush: 'Браузер',
  Sms: 'SMS',
}

export const channelName = value => channels[value] || value || '—'

export const isSmsChannel = value => String(value).toLowerCase() === 'sms'

const campaignStatuses = {
  Scheduled: { text: 'Запланирована', color: 'info' },
  Sending: { text: 'Отправляется', color: 'warning' },
  Completed: { text: 'Завершена', color: 'success' },
  Cancelled: { text: 'Отменена', color: 'secondary' },
  Failed: { text: 'Не отправлена', color: 'error' },
}

const recipientStatuses = {
  Pending: { text: 'Ждёт отправки', color: 'info' },
  Queued: { text: 'В очереди', color: 'success' },
  NoDevice: { text: 'Нет устройства', color: 'warning' },
  Unsubscribed: { text: 'Отказался от рассылок', color: 'secondary' },
}

const smsStatuses = {
  Sent: { text: 'Отправлено', color: 'success' },
  Failed: { text: 'Не отправлено', color: 'error' },
  Pending: { text: 'Отправляется', color: 'info' },
}

const colorOf = statuses => value => (statuses[value] || { color: 'secondary' }).color

const itemsOf = statuses => [
  { text: 'Все', value: null },
  ...Object.keys(statuses).map(value => ({ text: statuses[value].text, value })),
]

export const campaignStatusColor = colorOf(campaignStatuses)

export const campaignStatusItems = itemsOf(campaignStatuses)

export const recipientStatusColor = colorOf(recipientStatuses)

export const recipientStatusItems = itemsOf(recipientStatuses)

export const smsStatusColor = colorOf(smsStatuses)

export const smsStatusItems = itemsOf(smsStatuses)

export const templateTextKey = (code, language) => `${code}:${language}`

export const eventKey = code => `event:${code}`

export const eventGroups = [
  { code: 'order', name: 'Заказ' },
  { code: 'birthday', name: 'День рождения' },
  {
    code: 'geo',
    name: 'Рядом с филиалом',
    note: 'Заработает, когда выйдет версия приложения с геозонами: зону вокруг филиала отслеживает телефон.',
  },
]

export const devicesText = count => {
  const ones = count % 10
  const tens = count % 100

  if (ones === 1 && tens !== 11) return `${count} устройство`
  if (ones >= 2 && ones <= 4 && (tens < 12 || tens > 14)) return `${count} устройства`

  return `${count} устройств`
}

export const campaignChannels = campaign => (campaign && campaign.stats && campaign.stats.channels) || []

export const campaignTotal = (campaign, field) => campaignChannels(campaign)
  .reduce((total, channel) => total + (channel[field] || 0), 0)
